// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** TODO: Clean CSS, remove unused style **/
h1 {
  font-size: 28px;
}

tr.topMenu td {
  height: 32px;
}

.noRightBorder {
  border-right: none;
}

.topHead {
  height: 70px;
}

ng-sidebar-container ::ng-deep .ng-sidebar__backdrop {
  background: #fff;
  opacity: 0;
}

.slidingSidebar {
  height: 100vh;
  width: 400px;
  background-color: #EDF2F5;
  padding: 25px;
}

#typeMenu {
  position: relative;
  top: 13px;
}

.clickMode {
  background-color: #EDF2F5;
}

#typeMenu div {
  padding: 0 3px;
}

#typeMenu div div {
  margin: auto;
  text-align: center;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.typeSelected {
  border-bottom: 5px solid #007566;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  margin: 27px -11px;
  border: 1px solid #EDF2F5;
  background-color: white;
  min-width: 160px;
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

app-main-list-search-bar ::ng-deep .filterButton {
  display: none;
}

ngx-loading ::ng-deep div.backdrop {
  top: 192px;
}

ngx-loading ::ng-deep div div.spinner-three-bounce {
  position: fixed;
  z-index: 999;
}

.margin-for-container {
  margin-top: 1.3em;
}

.radioAdmin {
  margin: auto 7px auto 15px;
}

.firstRadioAdmin {
  margin-left: auto;
}

.radio-container {
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-list-search-filters/administration-list-search-filters.component.scss"],"names":[],"mappings":"AAAA,2CAAA;AAEA;EACI,eAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,gCAAA;AAAJ;;AAGA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;AAAJ;;AAGA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AAAJ;;AAGA,8BAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;AAAJ;;AAGA,oCAAA;AACA;EACI,cAAA;AAAJ;;AAGA,0FAAA;AACA;EACI,yBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ","sourcesContent":["/** TODO: Clean CSS, remove unused style **/\n\nh1 {\n    font-size: 28px;\n}\n\ntr.topMenu td {\n    height: 32px;\n}\n\n.noRightBorder {\n    border-right: none;\n}\n\n.topHead {\n    height: 70px;\n}\n\nng-sidebar-container ::ng-deep .ng-sidebar__backdrop {\n    background: #fff;\n    opacity: 0;\n}\n\n.slidingSidebar {\n    height: 100vh;\n    width: 400px;\n    background-color: #EDF2F5;\n    padding: 25px;\n}\n\n#typeMenu {\n    position: relative;\n    top: 13px\n}\n\n.clickMode {\n    background-color: #EDF2F5;\n}\n\n#typeMenu div {\n    padding: 0 3px;\n}\n\n#typeMenu div div {\n    margin: auto;\n    text-align: center;\n    cursor: pointer;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.typeSelected {\n    border-bottom: 5px solid #007566\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    margin: 27px -11px;\n    border: 1px solid #EDF2F5;\n    background-color: white;\n    min-width: 160px;\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n/* Change the background color of the dropdown button when the dropdown content is shown */\n.dropdown:hover .dropbtn {\n    background-color: #3e8e41;\n}\n\napp-main-list-search-bar ::ng-deep .filterButton {\n    display: none;\n}\n\nngx-loading ::ng-deep div.backdrop {\n    top: 192px;\n}\n\nngx-loading ::ng-deep div div.spinner-three-bounce {\n    position: fixed;\n    z-index: 999;\n}\n\n.margin-for-container {\n    margin-top: 1.3em\n}\n\n.radioAdmin {\n    margin: auto 7px auto 15px;\n}\n\n.firstRadioAdmin {\n    margin-left: auto;\n}\n\n.radio-container {\n    margin-top: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
